import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthState } from '../../store/auth/auth.state';
import { HelperService } from '../../services/common/helper.service';
import { SKIP_BEARER_TOKEN } from '@waseel-asp/tpa-waseel-lib-staging';

export const AuthInterceptor: HttpInterceptorFn = (request, next) => {
  const store = inject(Store);
  const token = store.selectSnapshot(AuthState.token);
  const helperService = inject(HelperService);

  if (token && (!request.url.includes("/assets/i18n/") && !request.context.get(SKIP_BEARER_TOKEN)))
    return next(helperService.cloneRequestWithNewToken(request, token));
  else
    return next(request);
};
